export default {
  components: {},
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  methods: {}
};